import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";


export interface OrganisationBranchConnectionListItem {
  id: string;
  // The organisation_branch_connections id, needed to hang catalogue rules off this branch.
  connectionId: string;
  
  name: string;
  logo: string;
  favicon: string;  
  baseline: string;
  catalogUrl: string;
  
  active: boolean;
  connected: boolean;
  academy:boolean;
  canActivate:boolean;
  
}

@Injectable({
  providedIn: 'root'
})

export class OrganisationBranchConnectionListItemAdapter implements Adapter<OrganisationBranchConnectionListItem> {
  adapt(item: any): OrganisationBranchConnectionListItem {
    return {
      id: item.id,
      connectionId: item.connectionId??'',
      name: item.name??'',
      logo: item.logo??'',
      catalogUrl: item.catalogUrl??'',
      favicon: item.favicon??'',
      baseline:item.baseline??'',
      active:item.connectionActive??false,
      connected:item.connectionExists??false,
      academy:true,
      canActivate: !item.connectionActive
    }
  }
}
